import { useEffect, useState } from "react";
import { showMessageError } from "../../../../../classes/functions";
import api from "../../../../../config";

export default function Table({commitments, setDetails, showModals, labels, indexes, feature}){
    const [features, setFeatures] = useState([]);

    function getParamsToModalURL(item){
        console.log(item.produto, item.armazem, item.lote, item.palete, item.cliente);
        let params = `produto=${item.codigo_produto}&empresa=${localStorage.getItem("empresa")}&armazem=${item.armazem}&lote=${item.lote}`;

        if(item.palete){
            params += `&etiqueta_palete=${item.etiqueta_palete}`;
        }

        if(item.cliente){
            params += `&cliente=${item.cliente}`
        }

        return params;
    }

    function getData() {
        api
        .get("/api/balances/getDataPage")
        .then((response) => {
            setFeatures(response.data.caracteristicas);
        }).catch((error) => {
            if (error?.response?.data) {
                showMessageError(error.response.data);
            }
        });
    }
    
    function getDataFeaturesByBalance(item) {
        api.get(`/api/balances/getDataFeaturesByBalance?${getParamsToModalURL(item)}`)
        .then((response) => {
            feature?.setState(response.data.caracteristicas);
            showModals?.setState((prevState) => ({...prevState, feature: true}));
        }).catch((error) => {
            if (error?.response?.data) {
            showMessageError(error.response.data);
            }
        });
    }
    
    function getMacAndSerieNumbers(item){
        api
        .get(`/api/balances/getDetailsByBalance?${getParamsToModalURL(item)}`)
        .then((response) => {
            setDetails(response.data);
            showModals?.setState((prevState) => ({...prevState, details: true}));
        })
        .catch((error) => {
            if (error?.response?.data){
                showMessageError(error.response.data);
            }
        });
    }    

    useEffect(() => {
        getData();
    }, []);

    return (
        <div className="divGroup" style={{overflowX: "scroll", maxWidth: "100%"}}>
            <table>
                <thead>
                    <tr>
                        {labels?.map((label, index) => {
                            return (
                                <th scope="col" key={index}>{label}</th>
                            )
                        })}
                        <th>Detalhes</th>
                        {features?.filter((feature) => feature?.controls_balance === "S")?.length > 0 &&
                            <th scope="col">Características</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {commitments.map((commitment, commitmentIndex) => {
                        return (
                            <tr key={commitmentIndex}>
                                {indexes?.map((index, indexIndex) => {
                                    return (
                                        <td scope="col" key={indexIndex}>{commitment[index]}</td>
                                    )
                                })}
                                <td scope="col" data-label="Detalhes">
                                    <button type="button" className="buttonTable" onClick={() => getMacAndSerieNumbers(commitment)}>Ver Detalhes</button>
                                </td>
                                {features.filter((feature) => feature.controls_balance === "S").length > 0 && <td scope="col" data-label="Características">
                                    <button type="button" className="buttonTable" onClick={() => getDataFeaturesByBalance(commitment)}>Ver características</button>
                                </td>}
                            </tr>
                        )
                    })}
                    {commitments?.length === 0 && 
                        <tr>
                            <td colSpan={7}><label className='required'>Nenhum registro encontrado!</label></td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}